import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacyForm';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  borderColor: palette.form.border,
  labelColor: palette.text.midGray,
  focusColor: palette.focus.normal,

  checkBoxRadio: {
    borderColor: palette.grey.G600,
    backgroundColor: palette.background,
    textColorDisabled: '#b8b8b8',
    backgroundColorDisabled: '#ddd',
    backgroundColorChecked: palette.primary.darkBackground,
    checkedColor: palette.text.light,
    labelColor: '#666'
  }
});

const styles = ({ legacyForm }) => (legacyForm ? {
  root: {
    '& select, & input, & textarea': {
      border: `1px solid ${legacyForm.borderColor}`,
      borderRadius: 2,
      '&:focus': {
        border: `1px solid ${legacyForm.focusColor}`
      }
    },
    '& input.form-control': {
      height: 34
    },
    '& .input-group-addon': {
      borderRadius: 2
    },
    '& label, & label.optional': {
      fontSize: 10,
      textTransform: 'uppercase',
      color: legacyForm.labelColor
    },
    '& .optional': {
      fontSize: 12
    },
    '& .checkbox, & .checkbox-inline': {
      '& label': {
        fontSize: 12,
        textTransform: 'none'
      }
    },
    '& .checkbox input': {
      '&:focus': {
        '& + label::before': {
          border: `1px solid ${legacyForm.focusColor}`
        }
      }
    },
    '& .checkbox input, & .checkbox-inline input': {
      position: 'absolute',
      opacity: 0,
      '& + label': {
        position: 'relative',
        cursor: 'pointer',
        padding: 0
      },
      '& + label::before': {
        content: '""',
        marginRight: 10,
        display: 'inline-block',
        verticalAlign: 'text-top',
        width: 16,
        height: 16,
        borderRadius: 2,
        border: `1px solid ${legacyForm.checkBoxRadio.borderColor}`,
        backgroundColor: legacyForm.checkBoxRadio.backgroundColor
      },
      '&:checked + label::before': {
        backgroundColor: legacyForm.checkBoxRadio.backgroundColorChecked
      },
      '&:disabled + label': {
        color: legacyForm.checkBoxRadio.textColorDisabled,
        cursor: 'auto'
      },
      '&:disabled + label::before': {
        boxShadow: 'none',
        backgroundColor: legacyForm.checkBoxRadio.backgroundColorDisabled
      },
      '&:checked + label::after': {
        content: '""',
        position: 'absolute',
        left: 6,
        top: 3,
        width: 5,
        height: 10,
        border: `solid ${legacyForm.checkBoxRadio.checkedColor}`,
        borderWidth: '0 1px 1px 0',
        transform: 'rotate(45deg)'
      }
    },
    '& .radio': {
      '& label': {
        fontSize: 12,
        textTransform: 'none'
      },
      '& [type="radio"]': {
        position: 'absolute',
        left: -9999
      },
      '& [type="radio"] + label': {
        position: 'relative',
        paddingLeft: 28,
        cursor: 'pointer',
        lineHeight: '20px',
        display: 'inlineBlock',
        color: legacyForm.checkBoxRadio.labelColor
      },
      '& [type="radio"] + label::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        width: 16,
        height: 16,
        border: `1px solid ${legacyForm.checkBoxRadio.borderColor}`,
        borderRadius: '100%',
        backgroundColor: legacyForm.checkBoxRadio.backgroundColor
      },
      '& [type="radio"] + label::after': {
        content: '""',
        width: 10,
        height: 10,
        backgroundColor: legacyForm.checkBoxRadio.backgroundColorChecked,
        position: 'absolute',
        top: 3,
        left: 3,
        borderRadius: '100%',
        transition: 'all 0.2s ease'
      },
      '& [type="radio"]:not(:checked) + label::after': {
        opacity: 0,
        transform: 'scale(0)'
      },
      '& [type="radio"]:checked + label::after': {
        opacity: 1,
        transform: 'scale(1)'
      },
      '& input': {
        '&[type="radio"]:disabled + label': {
          color: legacyForm.checkBoxRadio.textColorDisabled,
          cursor: 'auto'
        },
        '&:focus': {
          '& + label::before': {
            border: `1px solid ${legacyForm.focusColor}`
          }
        }
      }
    }
  }
} : {});
addModuleStyles(styles, themeKey, defaultTheme);
